export const ICON_LINK =
  'https://static.fuxi.netease.com/eevee-icon/resource/youlingtiangongweb-xinban/RiDQkM4BbaU3LS0.json';

export const QRCodeIMGWithdraw =
  'https://static.fuxi.netease.com/avatar/avatarkit/assets/qrcode/service-qrcode-withdraw.webp';
export const QRCodeIMG = 'https://static.fuxi.netease.com/avatar/avatarkit/assets/qrcode/service-qrcode.webp';

export const SimpleQRCode = 'https://static.fuxi.netease.com/avatar/avatarkit/assets/qrcode/qrcode-cs.webp';

export const DefaultTaxRate = '0.08';
export const DefaultUserRate = '0.1';

export const DefaultPlatformTaxRate = '0.08';
export const DefaultPlatformModeRate = '0.06';
export const DefaultPlatformUserRate = '0.1';
export const DefaultPlatformEnterpriseRate = '0.06';
